import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getAgreementListSearchValue = (state: IRootState) => state.agreementList.searchValue;
export const getAgreementListData = (state: IRootState) => state.agreementList.data;
export const getAgreementListOrder = (state: IRootState) => state.agreementList.order;
export const getAgreementListPage = (state: IRootState) => state.agreementList.page;
export const getAgreementListPageCount = (state: IRootState) => state.agreementList.pageCount;
export const getAgreementListTotalCount = (state: IRootState) => state.agreementList.totalCount;
export const getAgreementListRejected = (state: IRootState) => state.agreementList.rejected;
export const getAgreementListFindData = (state: IRootState) => state.agreementList.findData;
